import React from 'react';

export interface Layout {
    children: React.ReactNode;
    bundlesViewModel?: ELayout;
    maxWidthOverride?: string;
    desktopMaxWidth?: string;
    gapY?: string;
    gapX?: string;
    isPreview?: boolean;
    bundlesInternalViewModel?: string;
}

export enum EBundlesViewModel {
    LINEAR = 'linear',
    TWO_IN_ONE = 'twoInOne',
    THREE_IN_ONE = 'threeInOne'
}

export type ELayout = 'linear' | 'threeInOne' | 'twoInOne';
